import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { Ope } from 'src/app/models/Ope';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-secondary-nav',
  templateUrl: './secondary-nav.component.html',
  imports: [CommonModule,TooltipModule,MenuModule,RouterOutlet,ButtonModule],
  styleUrls: ['./secondary-nav.component.scss']
})
export class SecondaryNavComponent implements OnInit {
  items: MenuItem[] | undefined;
  mobileDisplay!: boolean;

  programme!: Ope;
  styleclasse: string = '';

  @HostListener('window:resize', ['$event.target.innerWidth'])

  onResize(width: number) {
    if (width <= 992) {
      this.mobileDisplay = true;
    } else {
      this.mobileDisplay = false;
    }
  }


  constructor(private scroller: ViewportScroller, public share: shareOpeSevices) { }
  ngOnInit() {

    // charger le nom et les info du programme sur la navbar
    this.share.datasOpe$.subscribe(res => this.programme = res);
    if (this.share.tabProgOpe.value == "options") {
      this.share.isDisplayOption = true,
        this.share.isDisplayGrilleprix = false,
        this.share.isDisplayPres = false,
        this.share.isDisplayDocument = false,
        this.share.isDisplaygalerie = false
    } else {
      this.share.isDisplayPres = true;
      this.share.isDisplayGrilleprix = false;
      this.share.isDisplayOption = false;
      this.share.isDisplayDocument = false;
      this.share.isDisplaygalerie = false;
    }

    this.items = [
      {
        label: 'Présentation',
        icon: 'icon-inc icon-building-invert',
        command: () => {
          this.share.isDisplayPres = true, this.share.isDisplayGrilleprix = false, this.share.isDisplayOption = false,
            this.share.isDisplayDocument = false, this.share.isDisplaygalerie = false
        },
        styleClass: this.styleclasse
      },

      {
        label: 'Galerie photos',
        icon: 'icon-inc icon-camera-invert',
        command: () => {

          this.share.isDisplaygalerie = true,
            this.share.isDisplayPres = false,
            this.share.isDisplayGrilleprix = false,
            this.share.isDisplayOption = false,
            this.share.isDisplayDocument = false


        },
        styleClass: this.styleclasse
      },

      {
        label: 'Documents',
        icon: 'icon-inc icon-document-invert',
        command: () => {
          this.share.isDisplayDocument = true, this.share.isDisplayGrilleprix = false,
            this.share.isDisplayPres = false,
            this.share.isDisplayOption = false, this.share.isDisplaygalerie = false, this.setActiveClass(true)
        },

        styleClass: this.styleclasse

      },

      {
        label: 'Options',
        icon: 'icon-inc icon-handshake-invert',
        command: () => {

          this.share.isDisplayOption = true, this.share.isDisplayGrilleprix = false, this.share.isDisplayPres = false, this.share.isDisplayDocument = false,
            this.share.isDisplaygalerie = false
        },
        styleClass: this.styleclasse

      },

      {
        label: 'Grille de prix',
        icon: 'icon-inc icon-lots-invert',
        command: () => {

          this.share.isDisplayGrilleprix = true, this.share.isDisplayPres = false, this.share.isDisplayPres = false, this.share.isDisplayDocument = false,
            this.share.isDisplaygalerie = false, this.share.isDisplayOption = false
        },
        styleClass: this.styleclasse

      }
    ];

    if (window.innerWidth <= 768) { // 768px portrait
      this.mobileDisplay = true;
    }



  }


  setActiveClass(t: boolean) {
    if (t == true) { return this.styleclasse = 'emphasis' } else return this.styleclasse;
  }
  onScrollToAnchor() {
    // this.scroller.scrollToAnchor('main');
    this.scroller.scrollToAnchor("page-programme");
  }
}
